import React from "react";

interface CircularTimerProps {
    timeLeft: number; // seconds remaining
    time: number;     // total duration in seconds
    size?: number;    // optional size in pixels
    strokeWidth?: number; // optional stroke width
    centerText?: string;
    isTimeOver?: boolean; // optional flag to indicate if time is over
    isAbsolute?: boolean;
    /** Text color (e.g. "black" for Figma-style center timer) */
    textColor?: string;
    /** Tailwind text size class for center text (e.g. "text-2xl") */
    textSizeClass?: string;
}

const CircularTimer: React.FC<CircularTimerProps> = ({
    timeLeft,
    time,
    size = 100,
    strokeWidth = 10,
    centerText = "",
    isTimeOver = false,
    isAbsolute = true,
    textColor,
    textSizeClass = "text-[41px]",
}) => {

    const radius = (size - strokeWidth) / 2;
    const circumference = 2 * Math.PI * radius;

    const progress = Math.max(0, Math.min(1, (time - timeLeft) / time));
    const strokeDashoffset = circumference * (1 - progress);

    return (
        <>
            <div
                className={`relative w-fit ${isTimeOver ? "circular-timer-time-over" : ""}`}
            >
                {/* <svg width={size} height={size}>
                    <circle
                        stroke={isTimeOver ? "var(--timer-color, red)" : "#555"}
                        fill="transparent"
                        strokeWidth={strokeWidth}
                        cx={size / 2}
                        cy={size / 2}
                        r={radius}
                    />
                    <circle
                        stroke={isTimeOver ? "var(--inner-color, #ff8888)" : "#ccc"}
                        fill="transparent"
                        strokeWidth={strokeWidth - 2}
                        strokeLinecap="round"
                        strokeDasharray={circumference}
                        strokeDashoffset={strokeDashoffset}
                        cx={size / 2}
                        cy={size / 2}
                        r={radius}
                        transform={`rotate(-90 ${size / 2} ${size / 2})`}
                        style={{
                            filter: isTimeOver ? 'brightness(1.2)' : 'none'
                        }}
                    />
                </svg> */}

                <div
                    className={`font-medium ${textSizeClass} circular-timer-text ${isAbsolute ? "circular-timer-text-absolute" : ""} ${textColor === "black" ? "text-text-primary" : ""}`}
                    style={textColor ? { color: textColor } : undefined}
                >
                    {centerText}
                </div>
            </div>
        </>
    );
};

export default CircularTimer;
